export function compareTiles(a, b) {
  return a.fScore - b.fScore;
}
